const cubicBezierIn = "cubic-bezier(0.25, 0, 0.25, 1)";
const cubicBezierOut = "cubic-bezier(0, 0.75, 1, 0.75)";

export const transitionParams = {
  celebratory: {
    duration: {
      enter: 450,
      exit: 450,
    },
  },
  expressive: {
    duration: {
      enter: 250,
      exit: 250,
    },
  },
  performance: {
    duration: {
      enter: 130,
      exit: 130,
    },
  },
};

export const transitions = {
  celebratory: {
    in: {
      transitionDuration: `${transitionParams.celebratory.duration.enter}ms`,
      transitionTimingFunction: cubicBezierIn,
    },
    out: {
      transitionDuration: `${transitionParams.celebratory.duration.exit}ms`,
      transitionTimingFunction: cubicBezierOut,
    },
  },
  expressive: {
    in: {
      transitionDuration: `${transitionParams.expressive.duration.enter}ms`,
      transitionTimingFunction: cubicBezierIn,
    },
    out: {
      transitionDuration: `${transitionParams.expressive.duration.exit}ms`,
      transitionTimingFunction: cubicBezierOut,
    },
  },
  performance: {
    in: {
      transitionDuration: `${transitionParams.performance.duration.enter}ms`,
      transitionTimingFunction: cubicBezierIn,
    },
    out: {
      transitionDuration: `${transitionParams.performance.duration.exit}ms`,
      transitionTimingFunction: cubicBezierOut,
    },
  },
  userTriggeredDelay: "100ms",
  eventTriggeredDelay: "0ms",
};
